import LogoMark from './LogoMark';

export default function SiteFooter() {
    const year = new Date().getFullYear();

    return (
        <footer className="client-site-footer pt-12">
            <div className="py-12 md:py-12 bg-marshmallow text-licorice">
                <div className="flex-1 mx-auto w-full max-w-5xl p-4">
                    <a
                        href="https://www.insureworks.co.uk"
                        className="inline-flex text-lg font-semibold"
                        aria-label="Insureworks"
                    >
                        <LogoMark className="icon animated-logo flex-none w-10 lg:w-12 h-10 lg:h-[4.5rem] text-licorice" />
                    </a>

                    <div className="text-sm">
                        &copy;{year} InsureWorks Ltd. All rights reserved. Insureworks Ltd is an
                        appointed representative of Your Company Matters Ltd which is authorised and
                        regulated by the Financial Conduct Authority (FCA). Our Financial Services
                        Register number is 1040384, and our Principal&apos;s Financial Services
                        Register number is 486123. You can check this on the Financial Services
                        Register by visiting the FCA&apos;s website. Company Information Insureworks
                        Ltd is a company registered in England and Wales under company number
                        16312816. Registered Office: Insureworks Ltd, Longdown Lane, Willoughby,
                        Warwickshire, CV238AG.
                    </div>
                </div>
            </div>
        </footer>
    );
}
